import React from 'react';
import card from '../css/product-card.module.css';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles, Button, Card, CardActionArea } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    root: {
        width: '17rem',
        backgroundColor: 'var(--card-color)',
        display: 'flex',
        flexDirection: 'column',
    },
    button: {
        fontFamily: 'Open Sans',
    },
});
const ProductCard = ({ product }) => {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <Link
                to={`/liquors/${product.sku}`}
                style={{
                    color: 'inherit',
                    textDecoration: 'inherit',
                    flex: 1,
                }}
            >
                <CardActionArea className={classes.button}>
                    <div className={card.pic_bg}>
                        <img
                            src={
                                'https://firebasestorage.googleapis.com/v0/b/windsor-liquor.appspot.com/o/Liquors%2Fwine.png?alt=media'
                            }
                            className={card.pic}
                            alt="product"
                        />
                    </div>
                    <div className={card.content_bg}>
                        <h2 className={card.name}>{product.name}</h2>
                        <span className={card.size}>
                            {product.size && product.size}
                            {product.pack && ', ' + product.pack}
                        </span>
                        <span className={card.price}>
                            {'$' + product.salePrice}
                        </span>
                    </div>
                </CardActionArea>
            </Link>
        </Card>
    );
};

export default ProductCard;
